import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { humanize } from 'underscore.string';
import { getLocationTimezone, extractLocation } from 'helpers/locations';
import { withTranslation } from 'react-i18next';
import { withLocaleContext } from 'providers/locale-settings-context';
import AppointmentConfirmationBadge from './AppointmentConfirmationBadge';
import IconTextDisplay from '../../../v2/IconTextDisplay';
import { CalendarIcon } from 'lucide-react';

const isOnTime = (stop) => {
  if (!stop.window_start && !stop.window_end) {
    return false;
  }
  const { complete, timeline, window_end } = stop;
  return (
    (complete &&
      timeline.complete &&
      moment(timeline.complete.at).isBefore(moment(window_end))) ||
    moment().isBefore(window_end)
  );
};

class StopAppointmentWindow extends Component {
  static propTypes = {
    stop: PropTypes.shape({
      window_start: PropTypes.string,
      window_end: PropTypes.string,
      appointment_unconfirmed: PropTypes.bool,
      empty: PropTypes.bool,
      location: PropTypes.array,
    }).isRequired,
    shipment_type: PropTypes.oneOf(['shorthaul', 'drayage', 'rail']),
    editable: PropTypes.bool.isRequired,
    onEditAppointmentWindow: PropTypes.func.isRequired,
  };

  static defaultTypes = {
    shipment: 'shorthaul',
  };

  handleEditAppointmentWindow = () =>
    this.props.onEditAppointmentWindow(this.props.stop);

  render() {
    const { stop, shipment_type, editable } = this.props;

    const { appointment_unconfirmed, window_end, window_start, empty } = stop;

    const location = extractLocation(stop.location);
    const timezone = getLocationTimezone(location);

    const isDrayage = shipment_type === 'drayage';
    let needsAppointment = false;
    if (isDrayage && !window_start && !window_end && !empty) {
      needsAppointment = true;
    }
    const onTime = isOnTime(stop) && !needsAppointment ? {} : { color: 'red' };

    const dateNotSetForNonDrayage = !isDrayage && !window_start && !window_end;

    const appointmentStatusVisible = isDrayage && !empty;

    const heapClassName = `shipment-stopAppointmentWindow-editAppointmentWindow${humanize(
      shipment_type,
    )} heap`;

    this.props.stop.heapClassName = heapClassName;
    const { t, formatDateTime } = this.props;

    return (
      <div className="relative flex items-center mb-2">
        <div>
          <button
            disabled={!editable}
            className="block"
            onClick={this.handleEditAppointmentWindow}
            title={t('CLICK_APPOINTMENT_WINDOW')}
          >
            {!stop.window_start && !stop.window_end && (
              <IconTextDisplay
                className="items-center"
                icon={<CalendarIcon className="w-4 h-4 text-gray-700" />}
              >
                {!stop.empty && (
                  <div className="text-sm text-red-500">
                    {t('SET_APPOINTMENT')}
                  </div>
                )}
              </IconTextDisplay>
            )}
            <div className="space-y-2">
              {stop.window_start && (
                <IconTextDisplay
                  color="green"
                  icon={<CalendarIcon className="w-4 h-4" />}
                >
                  <dl className="text-left">
                    <dt className="mb-1 form-label">{t('START')}</dt>
                    <dd className="block text-sm text-gray-900">
                      {formatDateTime(stop.window_start, timezone, true)}
                    </dd>
                  </dl>
                </IconTextDisplay>
              )}
              {stop.window_end && (
                <IconTextDisplay
                  color="red"
                  icon={<CalendarIcon className="w-4 h-4" />}
                >
                  <dl className="text-left">
                    <dt className="mb-1 form-label">{t('END')}</dt>
                    <dd className="block text-sm text-gray-900">
                      {formatDateTime(stop.window_end, timezone, true)}
                    </dd>
                  </dl>
                </IconTextDisplay>
              )}
            </div>
          </button>
          {dateNotSetForNonDrayage && (
            <div className="mt-2">{t('NOT_SET')}</div>
          )}
          {appointmentStatusVisible && (
            <div className="mt-2 ml-10">
              <AppointmentConfirmationBadge
                confirmed={!appointment_unconfirmed}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withLocaleContext(StopAppointmentWindow));
